<template>
  <row drag-flag class="row">
    <template v-if="collapsed" v-slot:fold>
      <i
        :class="fold ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"
        @click="$emit('collapse')"
      ></i>
    </template>
    <template v-slot:prefix>
      <svg-icon icon-class="svgo_drag"></svg-icon>
    </template>
    <div v-show="!enableEdit">
      {{ data.name }}
      <el-tag v-if="data.shared" size="small" style="margin-left: 5px">
        公开
      </el-tag>
    </div>
    <el-input
      v-show="enableEdit"
      ref="nameInput"
      v-model="editedName"
      size="mini"
      style="width: 100%"
      autofocus
      @blur="nameInputBlur"
      @keyup.native.enter="nameInputBlur"
    ></el-input>
    <template v-slot:suffix>
      <el-tooltip :content="contentText.edit">
        <i v-if="editable" class="el-icon-edit operation-icon" @click="handleEdit"></i>
      </el-tooltip>
      <el-tooltip :content="contentText.delete">
        <i v-if="deletable" class="el-icon-delete operation-icon" @click="$emit('delete')"></i>
      </el-tooltip>
    </template>
  </row>
</template>

<script>
import Row from "@/components/BaseComponents/Panel/Row"

export default {
  name: "menu-item",
  components: {
    Row
  },
  props: {
    data: Object,
    type: String,
    deletable: {
      type: Boolean,
      default: true
    },
    editable: Boolean,
    collapsed: Boolean,
    fold: Boolean
  },
  data() {
    return {
      editedName: "",
      enableEdit: false
    }
  },
  computed: {
    contentText() {
      if (this.type == "group")
        return {
          delete: "删除分组",
          edit: "编辑分组名称"
        }
      else if (["app", "project"].includes(this.type))
        return {
          delete: "移至未分组列表"
        }
      return {}
    }
  },
  methods: {
    handleEdit() {
      this.editedName = this.data.name
      this.enableEdit = true
      this.$nextTick(() => this.$refs.nameInput.focus())
    },
    nameInputBlur() {
      this.enableEdit = false
      this.data.name = this.editedName
    }
  }
}
</script>

<style lang="scss" scoped>
.row {
  height: 46px;
  line-height: 46px;
  background-color: #eee;
  border-radius: 0;
  margin-bottom: 0;
  border-bottom: 1px solid #f9f9f9;
  ::v-deep .suffix {
    margin-right: 4px;
    &:hover {
      color: #2c3e50;
    }
    .operation-icon {
      padding: 5px 3px;
      &:hover {
        color: #409eff;
      }
    }
  }
}
.sortable-ghost {
  border-top: 1px solid #1989fa;
}
</style>
